<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import GradeTypes from '$lib/PageSections/GradeTypes/GradeTypes.svelte';
	import TubingColors from '$lib/PageSections/TubingColors/TubingColors.svelte';
	import WhatDoTheyCost from '$lib/PageSections/WhatDoTheyCost/WhatDoTheyCost.svelte';

	import BigShapedWindowImage from './images/big_shaped_window.png';
	import DrawingOfBigShapedWindowImage from './images/drawing_of_big_shaped_window.png';
	import ManInstallingSpecialShapesImage from './images/man_installing_special_shapes.png';
	import SolutionsSpecialShapesImage from './images/solutions_special_shapes.png';
</script>

<Section>
	<p>
		Do you have any arched, round or eyebrow windows? If they’re drafty, or if
		you need to create privacy or filter light, unusually shaped windows can
		prove challenging. It’s hard to find a replacement for unusually-shaped
		windows. And most storm windows come in squares and rectangles, nothing like
		the odd-shaped window that makes your house look so unique.
	</p>
	<p>
		If you have an especially large window, you may need to introduce a <a
			href="/about-indow/how-to-order/mullions">mullion</a
		>, which will divide your insert into more than one segment.
	</p>
	<Image
		alt="indow window solutions special shapes"
		src={ManInstallingSpecialShapesImage}
	/>
	<p>
		Indow’s custom-shaped window inserts are the perfect solution for blocking
		drafts in uniquely shaped windows. They can be cut to fit any form. Round,
		oval, batwing – you name it – Indow can create a specialty-shaped window
		insert that will block drafts and noise. Customize them further by getting
		them made in Privacy Grade to obscure what’s happening within or Museum
		Grade to filter damaging UV light, all without distracting from the window’s
		unique beauty.
	</p>
</Section>

<Section>
	<h2>How To Order Inserts For Specialty Shape Windows</h2>
	<p>
		First we'll help you determine if inserts are the best solution for you.
		Next, we'll guide you step-by-step through measuring & tracing your
		odd-shaped windows and then custom-cut your inserts for a perfect fit. Get a <a
			href="/indow-cost">free estimate</a
		> today to discuss pricing and begin your order!
	</p>
	<Image
		alt="indow window solutions special shapes"
		src={SolutionsSpecialShapesImage}
	/>
</Section>

<Section>
	<h2>Make Your Specialty-Shaped Window Inserts Just Right</h2>
	<p>
		There are a range of insert grades to choose from to make your unusual
		windows do what you need them to, whether it’s blocking UV light or reducing
		noise. You can also choose from three tubing colors so the inserts blend
		into your window frames.
	</p>
	<Image
		alt="indow window solutions special shapes"
		src={BigShapedWindowImage}
	/>
</Section>

<GradeTypes backgroundColor="grey-light" />

<TubingColors />

<GetAFreeEstimate />

<WhatDoTheyCost version={2} />

<Parallax image={DrawingOfBigShapedWindowImage} />
<Awards />
<FeaturedArticles />
